import { CountryItemDto } from './../../../models/dto/country-item.dto';
import { ItemTreeType } from './../../../models/enum/item-tree.enum';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from './../../../Services/http.service';
import { HelperService } from './../../../Services/helper.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormControl, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AnalysisTypeDto } from '../../../models/dto/analysis-type.dto';

@Component({
  selector: 'app-create-edit-org-customer-modal',
  templateUrl: './create-edit-org-customer-modal.component.html',
  styleUrls: ['./create-edit-org-customer-modal.component.css']
})
export class CreateEditOrgCustomerModalComponent implements OnChanges, OnInit {
  modalReference: NgbModalRef;
  formEdit: UntypedFormGroup;
  countryList: CountryItemDto[] = [];
  analysisTypes: AnalysisTypeDto[];
  isCustomerAdmin: boolean;

  cultureList: { culture: string }[] = [];
  timezoneList: { timezone: string }[] = [];
  marketList: object[] = [{ market: 'CE' }, { market: 'UKCA' }];
  uploadFormatList: { uploadFormat: string }[] = [
    { uploadFormat: 'file' },
    { uploadFormat: 'folder' }
  ];
  showControl = false;
  @Input() data: any;
  @Output() closeForm = new EventEmitter();
  @Output() emitData = new EventEmitter();
  @ViewChild('classic') public templateRef: TemplateRef<any>;

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'md'
  };

  constructor(
    private fb: UntypedFormBuilder,
    private helper: HelperService,
    public modalService: NgbModal,
    private http: HttpService,
    private translate: TranslateService) {
    this.formEdit = this.fb.group({
      name: [null, Validators.required],
      organization: [null, Validators.required],
      person: [null, Validators.required],
      address: [null, Validators.required],
      country: [null, Validators.required],
      market: [null, Validators.required],
      uploadFormat: [null, Validators.required],
      culture: [null, Validators.required],
      timezone: [null, Validators.required],
      // analysisTypes: this.fb.array([], minSelectedCheckboxes(1)),
      notes: [],
    });
  }

  get analysisFormArray() {
    return this.formEdit.controls.analysisTypes as FormArray;
  }

  ngOnInit() {
    this.getCountriesList();
    this.cultureList = this.helper.getSupportedCultures();
    this.timezoneList = this.helper.getAvailableTimezones();
  }

  getCountriesList() {
    this.http.getCountriesList().subscribe((resp) => {
      this.countryList = resp;
      this.showControl = true;
    });
  }

  open(isCustomerAdmin: boolean) {
    this.isCustomerAdmin = isCustomerAdmin;
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
  }

  cancelEdit() {
    this.closeForm.emit();
    this.clearAndCloseModal();
  }

  get isCustomer() {
    if (this.data) {
      const result = this.helper.isNodeHasParent(this.data) ? this.data.node.itemTreeType === ItemTreeType.customer : this.data.itemTreeType === ItemTreeType.customer;
      return result;
    }
    return false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && this.data) {
      const data = this.helper.isNodeHasParent(this.data) ? this.data.node.obj : this.data.obj;
      if (this.isCustomer) {
        this.orgControl.enable();
        this.personControl.enable();
        this.marketControl.enable();
        this.uploadFormatControl.disable();
        this.cultureControl.disable();
        this.timezoneControl.disable();
        this.nameControl.setValue(data['name'] ?? null);
        this.orgControl.setValue(data['organizationNumber'] ?? null);
        this.addressControl.setValue(data['invoiceAddress'] ?? null);
        this.countryControl.setValue(data['countryId'] ?? null);
        this.marketControl.setValue(data['market'] ?? null);
        this.personControl.setValue(data['contactPerson'] ?? null);
        this.notesControl.setValue(data['notes'] ?? null);
        // Analysis types
        this.analysisTypes = data['analysisTypes'] ?? [];
        this.addAnalysisTypes();
      } else {
        this.orgControl.disable();
        this.personControl.disable();
        this.marketControl.disable();
        this.uploadFormatControl.enable();
        this.cultureControl.enable();
        this.timezoneControl.enable();
        this.nameControl.setValue(data['name'] ?? null);
        this.addressControl.setValue(data['address'] ?? null);
        this.countryControl.setValue(data['countryId'] ?? null);
        this.cultureControl.setValue(data['culture'] ?? null);
        this.timezoneControl.setValue(data['timezone'] ?? null);
        this.uploadFormatControl.setValue(data['uploadFormat'] ?? 'file');
        this.notesControl.setValue(data['notes'] ?? null);
        this.deleteAnalysisType();
      }
    }
  }

  private deleteAnalysisType() {
    if (this.formEdit.contains('analysisTypes')) {
      this.formEdit.removeControl('analysisTypes');
    }
  }

  private addAnalysisTypes() {
    if (!this.formEdit.contains('analysisTypes')) {
      this.formEdit.addControl('analysisTypes', this.fb.array([]));
      this.analysisFormArray.setValidators(minSelectedCheckboxes(1));
    }
    this.analysisFormArray.clear();
    this.analysisTypes.forEach(() => {
      this.analysisFormArray.push(new FormControl(false));
    });
    this.analysisTypes.forEach((analysisType, index) => {
      this.analysisFormArray.at(index).setValue(analysisType.enabled);
      if (this.isCustomerAdmin) {
        this.analysisFormArray.at(index).disable();
      }
    });
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.formEdit.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  saveData() {
    this.trimControlsValue();
    this.formEdit.markAllAsTouched();
    if (this.formEdit.invalid) {
      const invalidControls = this.findInvalidControls();
      console.log('Invalid controls:', invalidControls);
      return;
    }
    const { obj } = this.helper.isNodeHasParent(this.data) ? this.data.node : this.data;
    obj['name'] = this.nameControl.value;
    obj['countryId'] = this.countryControl.value;
    obj['notes'] = this.notesControl.value;
    if (this.isCustomer) {
      obj['invoiceAddress'] = this.addressControl.value;
      obj['contactPerson'] = this.personControl.value;
      obj['organizationNumber'] = this.orgControl.value;
      obj['market'] = this.marketControl.value;
      obj['analysisTypes'] = this.getSelectedAnalysisTypes();
    } else {
      obj['address'] = this.addressControl.value;
      obj['culture'] = this.cultureControl.value;
      obj['timezone'] = this.timezoneControl.value;
      obj['uploadFormat'] = this.uploadFormatControl.value;
    }
    this.emitData.emit(this.data);
    this.clearAndCloseModal();
  }

  getSelectedAnalysisTypes(): any {
    this.analysisFormArray.controls.forEach((control, index) => {
      this.analysisTypes[index].enabled = control.value;
    });
    return this.analysisTypes;
  }

  trimControlsValue() {
    if (this.nameControl.value) { this.nameControl.setValue(this.nameControl.value.trim()); }
    if (this.orgControl.value) { this.orgControl.setValue(this.orgControl.value.trim()); }
    if (this.addressControl.value) { this.addressControl.setValue(this.addressControl.value.trim()); }
    if (this.countryControl.value) { this.countryControl.setValue(this.countryControl.value.trim()); }
    if (this.marketControl.value) { this.marketControl.setValue(this.marketControl.value.trim()); }
    if (this.cultureControl.value) { this.cultureControl.setValue(this.cultureControl.value.trim()); }
    if (this.timezoneControl.value) { this.timezoneControl.setValue(this.timezoneControl.value.trim()); }
    if (this.personControl.value) { this.personControl.setValue(this.personControl.value.trim()); }
    if (this.notesControl.value) { this.notesControl.setValue(this.notesControl.value.trim()); }
  }

  clearAndCloseModal() {
    this.formEdit.reset();
    this.modalReference.close();
  }

  get getHeader() {
    const orgTitle = this.translate.instant('CUSTOMER_ORG_FORM.HEADER_ORG');
    const customerTitle = this.translate.instant('CUSTOMER_ORG_FORM.HEADER_CUSTOMER');
    return this.isCustomer ? customerTitle : orgTitle;
  }

  get nameControl() {
    return this.formEdit.controls['name'];
  }

  get orgControl() {
    return this.formEdit.controls['organization'];
  }

  get addressControl() {
    return this.formEdit.controls['address'];
  }

  get personControl() {
    return this.formEdit.controls['person'];
  }

  get countryControl() {
    return this.formEdit.controls['country'];
  }

  get marketControl() {
    return this.formEdit.controls['market'];
  }

  get uploadFormatControl() {
    return this.formEdit.controls['uploadFormat'];
  }

  get cultureControl() {
    return this.formEdit.controls['culture'];
  }

  get timezoneControl() {
    return this.formEdit.controls['timezone'];
  }

  get notesControl() {
    return this.formEdit.controls['notes'];
  }

  get analysisTypesControl() {
    return this.formEdit.controls['analysisTypes'];
  }

  enableSaveBtn() {
    if (this.data) {
      const { obj } = this.helper.isNodeHasParent(this.data) ? this.data.node : this.data;
      const hasNameChanges = obj['name'] !== this.nameControl.value;
      const hasCountryIdChanges = obj['countryId'] !== this.countryControl.value;
      const hasNotesChanges = obj['notes'] !== this.notesControl.value;
      const hasGenericChanges = hasNameChanges || hasCountryIdChanges || hasNotesChanges;

      if (this.isCustomer) {
        const hasInvoiceAddressChanges = obj['invoiceAddress'] !== this.addressControl.value;
        const hasPersonChanges = obj['contactPerson'] !== this.personControl.value;
        const hasOrgNumberChanges = obj['organizationNumber'] !== this.orgControl.value;
        const hasMarketChanges = obj['market'] !== this.marketControl.value;
        const hasAnalysisTypesChanges = this.hasAnalysisTypesChanges();

        return hasGenericChanges || hasInvoiceAddressChanges || hasPersonChanges || hasOrgNumberChanges || hasMarketChanges || hasAnalysisTypesChanges;
      } else {
        const hasAddressChanges = obj['address'] !== this.addressControl.value;
        const hasCultureChanges = obj['culture'] !== this.cultureControl.value;
        const hasTimeZoneChanges = obj['timezone'] !== this.timezoneControl.value;
        const hasUploadFormatChanges = (obj['uploadFormat'] ?? 'file') !== this.uploadFormatControl.value;
        return hasGenericChanges || hasAddressChanges || hasCultureChanges || hasTimeZoneChanges || hasUploadFormatChanges;
      }
    } else {
      return false;
    }
  }
  hasAnalysisTypesChanges() {
    let idx = 0
    for (const control of this.analysisFormArray.controls) {
      if (this.analysisTypes[idx].enabled !== control.value) {
        return true;
      }
      idx++;
    }
    return false;
  }

}

function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (control: AbstractControl) => {
    const formArray = control as FormArray;
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}
